// localStorage-backed hook for the sidebar collapse state.
//
// Reads the value synchronously on mount so the sidebar never paints at one
// width and then snaps to the other. Writes on every change.

import { useEffect, useState } from 'react';

const KEY = 'cockpit-nav-collapsed';

function readInitial(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function useCollapsedSidebar(): [boolean, (next: boolean) => void] {
  const [collapsed, setCollapsed] = useState<boolean>(readInitial);

  useEffect(() => {
    try {
      window.localStorage.setItem(KEY, collapsed ? '1' : '0');
    } catch {
      // Ignore storage errors (private mode, quota, etc.).
    }
  }, [collapsed]);

  return [collapsed, setCollapsed];
}
